
import React from 'react'

const InsuranceFooter = () => (
    <div style={{ textAlign: "center", width: "100%", padding: "32px", fontSize: 14, color: "#ffffff", maxWidth: "100%", background: "#000066" }} >
        Stashfin is only acting as a facilitator. Any plan/policy availment or claim
        settlement shall be at the sole discretion of the third-party insurers.
    </div>
  )

export default InsuranceFooter